import isEqual from "lodash.isequal";
import deepClone from "lodash.clonedeep";
import deepMerge from "deepmerge";

const snakeToCamelCase = (str) => {
	return str.replace(/([-_][a-z])/g, (group) =>
		group
			.toUpperCase()
			.replace("-", "")
			.replace("_", "")
	);
};

const snakeCaseObjectKeysToCamelCase = (obj) => {
	const newObj = {};

	Object.keys(obj).forEach((key) => {
		newObj[snakeToCamelCase(key)] = obj[key];
	});

	return newObj;
};

function capitalizeFirstLetter(str) {
	return str.charAt(0).toUpperCase() + str.slice(1);
}

const firstLetterToLowerCase = (str) => {
	return str[0].toLowerCase() + str.substring(1);
};

const uniq = (arr) => {
	return [...new Set(arr)];
};

function wait(ms) {
	return new Promise((resolve) => setTimeout(resolve, ms));
}

const debounce = (func, wait, immediate) => {
	var timeout;
	return function() {
		var context = this,
			args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

const lastOf = (arr) => arr[arr.length - 1];

function filterNil(object) {
	return Object.fromEntries(
		Object.entries(object).filter(([key, value]) => {
			return !isNil(value);
		})
	);
}

// const getId = (() => {
// 	let id = 0;

// 	return id => {
// 		return ++id;
// 	};
// })();

//const deepClone = (obj) => JSON.parse(JSON.stringify(obj));

function groupByFn(arr, fn) {
	return arr.reduce((result, item) => {
		result[fn(item)] = result[fn(item)] ?? [];
		result[fn(item)].push(item);
		return result;
	}, {});
}

function groupBy(arr, keyOrFn) {
	if (typeof keyOrFn === "function") {
		const fn = keyOrFn;
		return groupByFn(arr, fn);
	} else {
		const key = keyOrFn;
		return groupByFn(arr, (item) => item[key]);
	}
}

const preloadImg = (fileName) => {
	if (Array.isArray(fileName)) {
		fileName.forEach((fileName) => {
			const img = new Image();
			img.src = fileName;
		});
	} else {
		let img = new Image();
		img.src = fileName;
	}
};

class Flag {
	constructor() {
		this._flags = {};
	}

	create(name) {
		this._flags[name] = true;
		setTimeout(() => {
			delete this._flags[name];
		});
	}

	test(name) {
		return this._flags[name] || false;
	}
}

function sortInKey(arr, propKey) {
	return arr.sort((a, b) => {
		if (a[propKey] < b[propKey]) return -1;
		return a[propKey] > b[propKey] ? 1 : 0;
	});
}

function justOneOfSame(arr, key) {
	const alreadyInKeys = {};

	return arr.reduce((result, item) => {
		const prop = item[key];
		if (!(prop in alreadyInKeys)) {
			result.push(item);
			alreadyInKeys[prop] = 1;
		}
		return result;
	}, []);
}

function filterByKey(obj, fn) {
	return Object.fromEntries(
		Object.entries(obj).filter(([key]) => {
			return fn(key);
		})
	);
}

function excludeKeys(obj, keys) {
	return filterByKey(obj, (key) => !keys.includes(key));
}

function getDistance(val1, val2) {
	return Math.abs(val1 - val2);
}

function getRect(el) {
	return el?.getBoundingClientRect?.() ?? {};
}

function padStr(str, max, padChar = "0") {
	str = "" + str;
	return str.length < max ? this.padStr(padChar + str, max) : str;
}

const getUid = (() => {
	let i = 0;
	return function(pref = "") {
		return pref + new Date().getTime() + i++;
	};
})();

function isNil(val) {
	return [undefined, null].includes(val);
}

function loopN(n, fn) {
	for (let i = 0; i < n; i++) {
		fn(i);
	}
}

function mapN(n, fn) {
	return Array.from({ length: n }, (_, i) => fn(i));
}

function formatDate(inputDate) {
	const options = { year: "numeric", month: "short", day: "numeric" };
	const date = new Date(inputDate);
	return date.toLocaleDateString("en-US", options);
}

function formatTime(inputDateTime) {
	const date = new Date(inputDateTime);
	const hours = date.getUTCHours();
	const minutes = date.getUTCMinutes();

	const formattedTime = `${hours
		.toString()
		.padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;

	return formattedTime;
}

export {
	snakeToCamelCase,
	snakeCaseObjectKeysToCamelCase,
	firstLetterToLowerCase,
	Flag,
	uniq,
	lastOf,
	preloadImg,
	debounce,
	sortInKey,
	justOneOfSame,
	filterByKey,
	excludeKeys,
	getDistance,
	getRect,
	padStr,
	getUid,
	capitalizeFirstLetter,
	groupBy,
	isNil,
	loopN,
	mapN,
	wait,
	deepClone,
	isEqual,
	deepMerge,
	formatDate,
	formatTime,
	filterNil,
};
